import styled from '@emotion/styled';
import { mobileOnly } from '../../utils/sharedStyles';

export const footerHeader = 'footer-header';
export const footerLink = 'footer-link';

export const StyledDivColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;
  .${footerHeader} {
    font: var(--podium-cds-typography-body2-strong);
    color: var(--podium-cds-color-text-primary);
    margin-bottom: 12px;
  }
  .${footerLink} {
    font: var(--podium-cds-typography-body2-strong);
  }

  @media (${mobileOnly}) {
    display: none;
  }
`;

export const StyledHeader = styled.h2`
  font: var(--podium-cds-typography-body2-strong);
  color: var(--podium-cds-color-text-primary);
  height: 32px;
  margin-bottom: 12px;
`;
